import { render, staticRenderFns } from "./modalImagenes.vue?vue&type=template&id=226c7687&scoped=true&"
import script from "./modalImagenes.vue?vue&type=script&lang=js&"
export * from "./modalImagenes.vue?vue&type=script&lang=js&"
import style0 from "./modalImagenes.vue?vue&type=style&index=0&id=226c7687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c7687",
  null
  
)

export default component.exports